<template>
  <div>
    <div class="pageTop">
        <div class="container clearfix">
            <span class="week">{{time}}</span> 　 职业教育人才培养认证指导中心
            <div class="link clearfix">
                <!-- <a href="http://www.cnzyjy.org.cn/">E-Mail</a> -->
            </div>
        </div>
    </div>
      <div class="header">
        <div class="container clearfix">
            <a href="http://www.cnzyjy.org.cn/" class="logo">
                <img :src="`${global.remoteIp}/uploads/${webConfigs.logopic}`" />
            </a>
            <div class="right">
                <div class="search">
                    <div>
                        <div class="input">
                            <!-- <i class="el-icon-search"></i> -->
                            <input type="text" id="key" name="key" v-model="keyWords" placeholder="搜索">
                        </div>
                        <input type="submit" class="submitBtn" @click="search()" value="搜索">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="nav">
        <div class="container">
            <ul class="clearfix">
                <li class="firstItem"><router-link to="/">首页</router-link></li>
                <li class="firstItem" v-for="(navmodel, index) in navs" :key="index">
                    <router-link
                        :to="navmodel.link"
                        >{{ navmodel.name }}</router-link
                      >
                    <div class="navSub" v-if="navmodel.type =='hasSub'">
                        <ul>
                            <li v-for="(navsub, indexex) in navmodel.navSubs" :key="indexex"><router-link :to="navsub.link">{{navsub.name}}</router-link></li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
    </div>
  </div>
</template>
<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  name: "head-nav",
  props: {
    webConfigs: Object,
    plates: Array,
  },
  data() {
    return {
      global,
      keyWords: "",
      contactour: "",
      aboutour: "",
      articles: [],
      navs: [],
      time: "",
      timer:{},
      querypath:global.isPhone()?'/inqCertM':'/inqCert'
    };
  },
  mounted() {
    this.timer = setInterval(this.getData, 1000);
    let navModels = [
      {
        name: "机构概况",
        type: "info",
      },
      {
        name: "通知公告",
        type: "view",
      },
      {
        name: "工作动态",
        type: "view",
      },
      {
        name: "信息查询",
        type:'hasSub',
        navSub:[
          {
            name: " 测评查询",
            type:"link",
            link: this.querypath+"?type=zyrc"
          },
          {
            name: "等级查询",
            type:"link",
            link: this.querypath+"?type=zydj"
          }
        ]
      },
      {
        name: "课题研究",
        type:'hasSub',
        navSub: [
          {
            name: "课题立项",
            type:"view"
          },
          {
            name: "课题公示",
            type:"view"
          },
          {
            name: "课题结项",
            type:"view"
          },
          {
            name: "学术成果",
            type:"view"
          }
        ]
      },
      {
        name: "专家智库",
        type:'hasSub',
        navSub: [
          {
            name: "专家观点",
            type:"view"
          },
          {
            name: "科普知识",
            type:"view"
          }
        ]
      },
      {
        name: "合作交流",
        type:'hasSub',
        navSub: [
          {
            name: "成果展示",
            type:"view"
          },
          {
            name: "合作项目",
            type:"view"
          }
        ]
      },{
        name: "培训基地",
        type:"view"
      },
      {
        name: "产学研结合",
        type:"view"
      },
      {
        name: "联系我们",
        type: "info",
      },
    ];
    // this.$axios.get("/api/categorys?page=1&limit=30").then((res) => {
    //   if (res.data) {
    let plates = this.plates;
    plates.forEach((plate) => {
      
      if (plate.name == "分会介绍") {
        this.aboutour = "/news/info/" + plate._id + "/000000";
      } else if (plate.name == "联系我们") {
        this.contactour = "/news/info/" + plate._id + "/000000";
      }
    });

    navModels.forEach((model) => {
      let nav;
      if (model.type == "query") {
        nav = {
          name: model.name,
          link: "/applySociety",
        };
      } else if (model.type == "home") {
        nav = {
          name: model.name,
          link: "/",
        };
      }else if (model.type == "company"){
        nav = {
          name: model.name,
          link: "/company",
          type:'link'
        };
      }else if (model.type == "export"){
        nav = {
          name: model.name,
          link: "/export",
          type:'link'
        };
      }else if (model.type == "hasSub")
      {
        let subs = model.navSub;
        nav = {
          navSubs:[]
        }
        for(let k = 0; k < subs.length; k++)
        {
          if(subs[k].type =='view')
          {
            for (let i = 0; i < plates.length; i++) {
              let plate = plates[i];
              if (subs[k].type == "info" && subs[k].name == plate.name) {
                nav.navSubs.push({
                  name: subs[k].name,
                  link: "/news/info/" + plate._id + "/000000",
                });
              } else if (subs[k].type == "view" && subs[k].name == plate.name) {
                nav.navSubs.push({
                  name: subs[k].name,
                  link: "/news/views/" + plate._id,
                });
              }else{
               
              }
            }
          }else{
            nav.navSubs.push({
              name: subs[k].name,
              link: subs[k].link,
            });
          }
        }
        nav.name = model.name;
        nav.type ='hasSub';
        console.log(nav.navSubs)
        nav.link = nav.navSubs[0]?nav.navSubs[0].link:'';
      }
      else {
        for (let i = 0; i < plates.length; i++) {
          let plate = plates[i];
          if (model.type == "info" && model.name == plate.name) {
            nav = {
              name: model.name,
              link: "/news/info/" + plate._id + "/000000",
            };
          } else if (model.type == "view" && model.name == plate.name) {
            nav = {
              name: model.name,
              link: "/news/views/" + plate._id,
            };
          }
        }
      }
      if (nav) this.navs.push(nav);
    });
     
  },
  created(){
    
  },
  methods: {
    getData() {
      
      let week = ["日", "一", "二", "三", "四", "五", "六"];
      let date = new Date();
      let getday = date.getDay();
      this.time= `${date.getFullYear()}年${
        date.getMonth() + 1
      }月${date.getDate()}日 ${('00'+date.getHours()).slice(-2)}:${('00'+date.getMinutes()).slice(-2)}:${('00'+date.getSeconds()).slice(-2)} 星期${week[getday]}`;
    },
    search() {
      this.$router.replace("/news/views/search?keyWords=" + this.keyWords);
    },
    toTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
};
</script>

<style scoped>
</style>
